"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3509%3A746))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:50:59.372Z
 */
export const ShareHeart = createSVGIcon(
  <>
    <path
      d="M14.9999 14.5714L8.14271 8.22853C4.40557 4.47424 9.857 -2.79433 14.9999 3.08567C20.1427 -2.77719 25.6456 4.49138 21.857 8.22853L14.9999 14.5714Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.856934 18.8571L5.04665 22.3473C5.66254 22.8609 6.43899 23.1424 7.24093 23.1428H18.2861C19.0746 23.1428 19.7141 22.5033 19.7141 21.7148C19.7141 20.1376 18.4352 18.8571 16.8564 18.8571H9.17808"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99979 17.1428L7.2855 18.4285C7.6265 18.7695 8.08898 18.961 8.57122 18.961C9.05346 18.961 9.51594 18.7695 9.85693 18.4285C10.1979 18.0875 10.3895 17.625 10.3895 17.1428C10.3895 16.6605 10.1979 16.198 9.85693 15.8571L7.8615 13.8616C7.21867 13.2186 6.34674 12.8572 5.4375 12.8571H0.856934"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ShareHeart",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
